import { Reveal, Overline } from "./Reveal";
import { CHAPTERS } from "./data";
import { Placeholder } from "./Placeholder";
import hallwayImg from "@/assets/hallway.png";
import doorImg from "@/assets/door.png";

export const Story = () => (
  <section id="story" data-testid="story-section" className="py-24 md:py-40 relative">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-6">
          <Reveal>
            <Overline>Why it's different</Overline>
            <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
              A stay unlike any other
            </h2>
            <p className="font-sans text-textMuted leading-relaxed mt-8 max-w-md">
              This isn't simply somewhere to sleep. It's a space designed for guests who appreciate something a little different — combining character, comfort and complete privacy. Guests often tell us they've never stayed anywhere quite like it.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10">
            <div className="grid grid-cols-2 gap-4 md:gap-5">
              <Placeholder label="Your own private entrance" src={doorImg} className="aspect-[3/4] w-full" parallax testId="story-image-placeholder" />
              <Placeholder label="Down to your cellar retreat" src={hallwayImg} className="aspect-[3/4] w-full" parallax testId="story-image-secondary" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:pt-4">
          <div className="divide-y divide-line/60 border-t border-line/60">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.1}>
                <article className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 group">
                  <span className="font-mono text-sm text-primary/70 pt-2">{c.no}</span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-textMain group-hover:text-primary transition-colors duration-500">
                      {c.title}
                    </h3>
                    <p className="font-sans text-textMuted leading-relaxed mt-4 max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
